module.exports = require('./dist/src/Loader');



//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-style-react/Loader.js
// module id = 69
// module chunks = 0 1